import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Timeline() {
  const [eras, setEras] = useState([]);
  useEffect(() => { api.get("/timeline").then((r) => setEras(r.data.eras)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-10">
      <p className="overline">A secondary way to explore</p>
      <h1 className="serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-1 mb-3">Timeline</h1>
      <p className="text-muted-foreground max-w-xl mb-12">Scroll through the centuries — from carved court furniture to moulded plastic and beyond.</p>

      <div className="space-y-16">
        {eras.map((group) => (
          <div key={group.era} className="grid lg:grid-cols-[180px_1fr] gap-6" data-testid={`timeline-era-${group.era}`}>
            <div className="lg:sticky lg:top-20 self-start">
              <h2 className="serif text-4xl text-accent">{group.era}</h2>
              <p className="text-sm text-muted-foreground mt-1">{group.chairs.length} chairs</p>
            </div>
            <div className="flex gap-5 overflow-x-auto no-scrollbar pb-4 -mx-5 px-5 lg:mx-0 lg:px-0">
              {group.chairs.map((c) => (
                <Link key={c.slug} to={`/chair/${c.slug}`} className="group shrink-0 w-56" data-testid={`timeline-chair-${c.slug}`}>
                  <div className="hover-zoom border border-border bg-card aspect-[3/4]">
                    <img src={c.image_url} alt={c.title} loading="lazy" className="w-full h-full object-cover" />
                  </div>
                  <h3 className="serif text-lg mt-2 leading-tight group-hover:text-accent transition-colors">{c.title}</h3>
                  <p className="text-xs text-muted-foreground">{c.designer} · {c.year}</p>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
